import { intervalToDuration, parseISO } from 'date-fns';
import { formatPluralization } from './index';

export const formatPetAge = (dateOfBirth: string): string => {
  const { months, years } = intervalToDuration({ start: parseISO(dateOfBirth), end: new Date() });

  const ageParts = [];

  if ((years ?? 0) >= 1) {
    ageParts.push(`${years} ${formatPluralization({ word: 'yr', singularCriteria: years })}`);
  }

  if ((months ?? 0) >= 1) {
    ageParts.push(`${months} ${formatPluralization({ word: 'mo', singularCriteria: months })}`);
  }

  return ageParts.join(', ');
};
